// client/src/services/tournamentService.js
// This file acts as a generic interface for tournament services.
// It currently re-exports functions from supabaseTournamentService.js.
// To switch tournament providers, modify this file to import from a different service.

import supabaseTournamentService from './supabase/supabaseTournamentService';

const tournamentService = {
  createTournament: (name, structure, timerState, details) => supabaseTournamentService.createTournament(name, structure, timerState, details),
  getTournamentsForUser: supabaseTournamentService.getTournamentsForUser,
  deleteTournament: (id) => supabaseTournamentService.deleteTournament(id),
  getAllTournaments: supabaseTournamentService.getAllTournaments,
  adminDeleteTournament: (id) => supabaseTournamentService.adminDeleteTournament(id),
  getTournamentById: (id) => supabaseTournamentService.getTournamentById(id),
  updateTournamentTimerState: (tournamentId, timerState, remainingTime, rowIndex, playStartTime) => supabaseTournamentService.updateTournamentTimerState(tournamentId, timerState, remainingTime, rowIndex, playStartTime),
  updateTournamentStructure: (tournamentId, name, structure, details, timerState) => supabaseTournamentService.updateTournamentStructure(tournamentId, name, structure, details, timerState),
  updateTournamentDetails: (tournamentId, details) => supabaseTournamentService.updateTournamentDetails(tournamentId, details),
  getUserTier: (userId) => supabaseTournamentService.getUserTier(userId),
  // 新しく追加するRealtime購読関連の関数
  subscribeToTournamentState: (tournamentId, callback, onStatusChange) => supabaseTournamentService.subscribeToTournamentState(tournamentId, callback, onStatusChange),
  unsubscribeFromTournamentState: (channel) => supabaseTournamentService.unsubscribeFromTournamentState(channel),
  updateTournamentState: (tournamentId, state) => supabaseTournamentService.updateTournamentState(tournamentId, state),
};

export default tournamentService;
